/**
 * The client mirror of the backend's `actor_is_internal_staff`
 * (src/utils/user_utils.py): a masquerading session, a superuser, or a
 * verified internal email domain. It deliberately ignores the `is_internal`
 * flag, which staff can set on real customers — that is
 * `isInternalUser`, the internal-FEATURE boundary, not the staff one.
 *
 * UI visibility only; every staff-only surface is also refused server-side.
 */
export const INTERNAL_STAFF_EMAIL_DOMAINS = ['@fibonaccipartner.com', '@leoads.ai', '@percuity.ai'];

export function isInternalStaffSession(
  currentUser: { email?: unknown; user_name?: unknown; is_superuser?: unknown } | null | undefined,
  isMasquerading: boolean,
): boolean {
  if (isMasquerading) return true;
  if (currentUser?.is_superuser === true) return true;
  const email = String(currentUser?.email ?? currentUser?.user_name ?? '').toLowerCase();
  return INTERNAL_STAFF_EMAIL_DOMAINS.some((domain) => email.endsWith(domain));
}
